$(document).ready(function(){

	// -- home slider --
	var bannerSlider = $('.slider.type--banner');
	var bannerSettings = {
		infinite: false,
		dots: true,
		arrows: true,
		appendArrows: $('.slick--arrows'),
		prevArrow: $('.slick--prev'),
		nextArrow: $('.slick--next'),
	};
	bannerSlider.slick(bannerSettings);


	// -- small slider --
	var smallSlider = $('.slider.type--small');
	$(smallSlider).each(function(){
		var current = $(this);
		current.slick({
			arrows: false,
			dots: false,
			infinite: false,
			adaptiveHeight: false,
		});
	});
	

	// -- large slider --
	var largeSlider = $('.slider.type--large');
	$(largeSlider).each(function(){
		var current = $(this);
		current.slick({
			infinite: false,
			dots: true,
			arrows: true,
			appendArrows: current.next('.slick--arrows'),
			prevArrow: current.next('.slick--arrows').find('.slick--prev'),
			nextArrow: current.next('.slick--arrows').find('.slick--next'),
		});
	});

});